module.exports = __webpack_public_path__ + "images/8d23ba8461852211fd64a54194121026-illu_lineart_Garage Door Sensor.png";